import { render, staticRenderFns } from "./TransferFunds.vue?vue&type=template&id=ae37524e&scoped=true"
import script from "./TransferFunds.vue?vue&type=script&lang=ts"
export * from "./TransferFunds.vue?vue&type=script&lang=ts"
import style0 from "./TransferFunds.vue?vue&type=style&index=0&id=ae37524e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae37524e",
  null
  
)

export default component.exports